export enum RolesEnum {
  THERAPIST = 'therapist',
  CLIENT_INDIVIDUAL = 'client-individual',
  CLIENT_CHILDREN = 'client-child',
}
